import { createSlice } from '@reduxjs/toolkit'
import AwardInterface from '../../interfaces/Award.interface'

const initialState: AwardInterface[] = []

export const awardsSlice = createSlice({
    name: 'awards',
    initialState,
    reducers: {
        setAwards: (_, { payload }) => payload,
        addAward: (state, { payload }) => {
            state.push(payload)
        },
        resetAwards: () => initialState
    }
})
export const { setAwards, addAward, resetAwards } = awardsSlice.actions
export default awardsSlice.reducer